import { PassportRequestFormValues } from './type';

export const initialValuesForm: PassportRequestFormValues = {
  purpose: '',
  remarks: '',
  fromDate: '',
  returnDate: '',
  totDays: '',
};
